import { fetchBaseQuery, createApi } from "@reduxjs/toolkit/query/react";

// Define the base query function
const baseQuery = fetchBaseQuery({
  baseUrl: `${import.meta.env.VITE_API_BASE_URL}/api`,
  prepareHeaders: (headers, { getState, endpoint }) => {
    // Don't add Authorization header for login, refresh-token, and logout endpoints
    if (endpoint === "loginApi") {
      headers.delete("Authorization");
      return headers;
    }
    const token = getState().auth.token;
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

// Create the base API slice
export const apiSlice = createApi({
  reducerPath: 'adminApi', // MOVE IT HERE
  baseQuery: baseQuery,
  endpoints: () => ({}),
  // tagTypes: ['LeaveType'],
});